import React, { useState, useCallback } from "react";
import { Row, Col, Drawer, Layout } from "antd";
import { Slider } from "react-burgers";

import MainMenu from "../mainMenu";
import UserInfo from "../userInfo";
import Languages from "../languages";
import config from "../../../config";
import Documents from "../../document/info";
import Notifications from "../../notifications";
import ExternalLink from "../generic/externalLink";

import "./index.css";

const { Header } = Layout;

const logoUrl = `${process.env.PUBLIC_URL}/logo/logo-dhl.png`;

function NavBar({ onSetCountOfDocs, onLanguageSetting }) {
  const [drawerVisible, setDrawerVisible] = useState();
  const onDrawerClose = useCallback(() => {
    setDrawerVisible(false);
  }, []);

  const onSliderClick = useCallback(() => {
    setDrawerVisible(!drawerVisible);
  }, [drawerVisible]);

  return (
    <Header className="navbar-header">
      <Row type="flex" justify="space-between" align="middle">
        <Col span={10}>
          <ExternalLink
            noTarget
            href={config.HOME_URL}
            titleId="header.backToMain"
            titleDefaultMessage="Přechod na hlavní stránku"
            content={
              <img alt="logo" src={logoUrl} className="navbar-header-logo" />
            }
          />
          <div className="menu-container">
            <MainMenu />
          </div>
        </Col>
        <Col>
          <Row
            type="flex"
            gutter={50}
            align="middle"
            justify="space-between"
            className="right-side-container"
          >
            <Documents onSetCountOfDocs={onSetCountOfDocs} />
            <Notifications />
            <Col className="language-container">
              <Languages onLanguageSetting={onLanguageSetting} />
            </Col>
            <Col className="user-container">
              <UserInfo />
            </Col>
            <Col className="drawer-menu-button">
              <Slider active={drawerVisible} onClick={onSliderClick} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Drawer
        closable={false}
        placement="right"
        onClose={onDrawerClose}
        visible={drawerVisible}
      >
        <Row gutter={[0, 50]}>
          <Col>
            <UserInfo />
          </Col>
        </Row>
        <Row gutter={[0, 50]}>
          <Col>
            <Languages onLanguageSetting={onLanguageSetting} />
          </Col>
        </Row>
        <Row gutter={[0, 50]}>
          <Col>
            <MainMenu mode="vertical" />
          </Col>
        </Row>
      </Drawer>
    </Header>
  );
}

export default NavBar;
